import React from "react";
import "../Styles/CheckBox.css";
import { SelectEvent } from "../Models/multiSelectEvent";
import { ListItemSelector } from "./ListItemSelector";
import { StrucCol } from "../../StructureElements/StrucCol";
import { StrucRow } from "../../StructureElements/StrucRow";

interface RowFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  multiSelect: boolean;
  index: number;
  isChecked: boolean;
  rowChecked: (event: SelectEvent) => void;
  bgColor?: string;
  disabled?: boolean;
}

export const ListItemFrame = React.forwardRef<HTMLDivElement, RowFrameProps>(
  (
    {
      children,
      className,
      multiSelect,
      rowChecked,
      index,
      isChecked,
      bgColor,
      disabled = false,
      onClick,
      ...rest
    },
    ref
  ) => {
    const s = React.Children.toArray(children)[0] as JSX.Element;
    return (
      <StrucRow
        className={`flex flex-row items-center min-h-10 pb-2 !text-xs hover:bg-gray-200 border-gray-100 ${
          !multiSelect ? "pl-8" : ""
        } ${bgColor ?? ""}`}
        {...rest}
      >
        {multiSelect && (
          <StrucCol size={0.53} onClick={(e) => e.stopPropagation()}>
            <ListItemSelector
              initialValue={isChecked}
              index={index}
              onRowSelectChange={rowChecked}
              disabled={disabled}
            />
          </StrucCol>
        )}
        <StrucCol onClick={onClick}>{children}</StrucCol>
      </StrucRow>
    );
  }
);
